import { Link, useParams } from "react-router-dom";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/layout/Breadcrumbs";

const TITLES = {
  "privacy-policy": "Privacy Policy",
  terms: "Terms of Use",
  "cookie-policy": "Cookie Policy",
  disclaimer: "Disclaimer",
};

export default function LegalPage() {
  const { doc } = useParams();
  const title = TITLES[doc] || "Legal";
  return (
    <>
      <SEO title={`${title} | The Vantage Institute™`} description={`${title} for The Vantage Institute™ website.`} path={`/legal/${doc}`} />
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: title }]} />
      <section className="container-x py-16 sm:py-24" data-testid="legal-page">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-4 font-display text-4xl font-semibold text-navy sm:text-5xl">{title}</h1>
        <span className="gold-rule mt-8 !w-24" aria-hidden="true" />
        <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-slate">
          <p>
            This document is being finalised by The Vantage Institute™ and will be published on this page.
          </p>
          <p>
            In the meantime: this website does not use tracking cookies, does not store personal data, and does
            not operate accounts, payments or subscriptions. Enquiry forms compose your message for you to send
            via an official Vantage channel — nothing is transmitted to or stored by this website.
          </p>
          <p>
            For any question regarding this {title.toLowerCase()}, please{" "}
            <Link to="/contact" className="text-link" data-testid="legal-contact-link">talk to Vantage</Link>.
          </p>
        </div>
      </section>
    </>
  );
}
